import {MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {
    SelectWithFallbackGrid,
    SelectWithFallbackPanelWrapper,
    StyledFormControl,
    StyledFormControlLabel
} from "./SelectWithFallback.styled";
import {ExpandMore} from "@mui/icons-material";

export type SelectWithFallbackOptionType = {
    value: string;
    label: string;
}

interface SelectWithFallbackProps {
    label: string;
    options: SelectWithFallbackOptionType[];
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

const SelectWithFallback = ({
    label,
    options,
    value,
    onChange,
    disabled = false,
}: SelectWithFallbackProps) => {
    const isEmpty = options.length === 0;
    const isValueAvailable = options.some(option => option.value === value);
    const selectedValue = isValueAvailable ? value : '';

    const handleChange = (e: SelectChangeEvent) => {
        onChange(e.target.value);
    };

    return (
        <SelectWithFallbackPanelWrapper>
            <SelectWithFallbackGrid>
                <StyledFormControl fullWidth disabled={isEmpty}>
                    <StyledFormControlLabel id="select-with-fallback-label">
                        {label}
                    </StyledFormControlLabel>

                    <Select
                        labelId={"select-with-fallback-label"}
                        inputProps={{ 'aria-labelledby': 'select-with-fallback-label' }}
                        value={selectedValue}
                        displayEmpty
                        IconComponent={ExpandMore}
                        onChange={handleChange}
                        disabled={isEmpty || disabled}
                    >
                        {options.map((option) => (
                           <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </StyledFormControl>
            </SelectWithFallbackGrid>
        </SelectWithFallbackPanelWrapper>
    );
};

export default SelectWithFallback;